import React, { ReactElement, useEffect } from 'react'
import StepTitle from '../StepTitle'
import TooltipWrapper from '../tooltips/TooltipWrapper'
import { IStepProps } from '../../interfaces/Step'
import Step6Tooltip from '../tooltips/Step6Tooltip'
import File from './File'
import Step6Form from './Step6Form'

function Step6(props: IStepProps): ReactElement {
  const { title } = props

  useEffect(() => {
    window.scroll(0, 0)
  }, [])

  return (
    <>
      <StepTitle title={title}>
        <TooltipWrapper title="Pourquoi ce document ?">
          <Step6Tooltip />
        </TooltipWrapper>
      </StepTitle>
      <File />
      <Step6Form {...props} />
    </>
  )
}

export default Step6
